import { TwContainer } from '~/lib/TwContainer';
import img5 from '/images/proofreading.svg';
import img4 from '/images/user-profile.svg';
import img3 from '/images/development.svg';
import img2 from '/images/website.svg';
import img1 from '/images/ux-design.svg';
import { Card, Flex, Stack, Text } from '@mantine/core';

export const SectionThree = () => {
	return (
		<section
			className="bg-white"
			style={{
				backgroundImage: 'url(/headerBg.png)',
				backgroundPosition: '100%',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
			}}>
			<TwContainer className="pt-16 md:pb-56 pb-44 px-8 flex flex-wrap gap-12 justify-center items-center">
				<Stack className={'col-span-full flex flex-col mx-auto  text-center gap-2'}>
					<h1 className="text-base font-medium font-saira max-w-3xl text-gray-400">Solutions We provide</h1>
					<h1 className="text-5xl font-semibold text-white font-saira max-w-3xl mt-0">We make IT simple, faster, and less expensive.</h1>
				</Stack>
				<Text className={'text-center text-base text-gray-100 max-w-3xl'}>
					Our software company that offers a comprehensive range of IT services, including UI/UX design, frontend, backend, mobile app development,
					and data scraping. Our company is dedicated to delivering high-quality services that exceed our client's expectations.
				</Text>
				<Flex className={'flex flex-row flex-wrap justify-center gap-12'}>
					<Card className={'md:basis-2/5'}>
						<div className={'flex md:flex-row flex-col gap-4 p-6'}>
							<img
								src={img1}
								className={'max-w-[130px] mx-auto'}
							/>
							<div>
								<h4 className={'font-semibold text-accent font-saira'}>UI/UX Design</h4>
								<p className={'text-whitesmoke font-inter pt-2 mb-0'}>
									Our team of experienced designers uses the latest tools and technologies to create user-friendly and intuitive designs that enhance
									the user experience. We believe that good design is essential for attracting and retaining customers, and we work closely with our
									clients to ensure that the design meets their requirements.
								</p>
							</div>
						</div>
					</Card>
					<Card className={'md:basis-2/5'}>
						<div className={'flex md:flex-row flex-col gap-4 p-6'}>
							<img
								src={img2}
								className={'max-w-[130px] mx-auto'}
							/>
							<div className={'my-auto'}>
								<h4 className={'font-semibold text-accent font-saira'}>Frontend Development</h4>
								<p className={'text-whitesmoke font-inter pt-2 mb-0'}>
									Our frontend developers use the latest frameworks and technologies to create responsive and fast-loading websites and web
									applications. We have experience in developing complex frontend systems that are user-friendly and accessible.
								</p>
							</div>
						</div>
					</Card>
					<Card className={'md:basis-2/5'}>
						<div className={'flex md:flex-row flex-col gap-4 p-6'}>
							<img
								src={img3}
								className={'max-w-[130px] mx-auto'}
							/>

							<div>
								<h4 className={'font-semibold text-accent font-saira'}>Backend Development</h4>
								<p className={'text-whitesmoke font-inter pt-2 mb-0'}>
									Our backend developers use a variety of programming languages and frameworks to create robust, scalable, and secure backend systems.
									We have expertise in building complex backend systems that can handle large amounts of data and high levels of traffic.
								</p>
							</div>
						</div>
					</Card>
					<Card className={'md:basis-2/5 '}>
						<div className={'flex md:flex-row flex-col gap-4 p-6'}>
							<img
								src={img4}
								className={'max-w-[130px] mx-auto'}
							/>

							<div>
								<h4 className={'font-semibold text-accent font-saira'}>Mobile App Development</h4>
								<p className={'text-whitesmoke font-inter pt-2 mb-0'}>
									Our mobile app developers specialize in creating cross-platform mobile applications that are user-friendly, efficient, and
									effective. We use the latest tools and technologies to develop mobile applications that work seamlessly on different platforms and
									devices.
								</p>
							</div>
						</div>
					</Card>
					<Card className={'md:basis-2/5 '}>
						<div className={'flex md:flex-row flex-col gap-4 p-6'}>
							<img
								src={img5}
								className={'max-w-[130px] mx-auto'}
							/>
							<div>
								<h4 className={'font-semibold text-accent font-saira'}>Data Scraping</h4>
								<p className={'text-whitesmoke font-inter pt-2 mb-0'}>
									Our data scraping services help our clients to gather, analyze, and extract data from various sources. We use automated tools and
									technologies to scrape data efficiently and accurately.
								</p>
							</div>
						</div>
					</Card>
				</Flex>
				<Text className={'text-center text-base text-gray-100'}>
					We follow a proven software development process that involves continuous communication with our clients. We work closely with our clients to
					understand their requirements and goals, and we provide regular updates on the progress of the project. Our goal is to ensure that our
					clients are satisfied with the final product and that it meets their expectations.
					<br />
					<br />
					At our software company, we are committed to delivering high-quality services that provide our clients with a competitive advantage. Contact
					us today to learn more about how we can help you with your UI/UX design, frontend, backend, mobile app development, or data scraping
					project.
				</Text>
			</TwContainer>
		</section>
	);
};
